import { Component, OnInit } from '@angular/core'
import { LoginFormComponent } from '../../../features/login/login-form/login-form.component'
import { ForgotFormComponent } from '../../../features/login/forgot-form/forgot-form.component'
import { CacheService } from '../../../core/services/cache/cache.service'
import { AuthLayoutComponent } from '../../../shared/components/auth-layout/auth-layout.component'

@Component({
  selector: 'login',
  imports: [LoginFormComponent, ForgotFormComponent, AuthLayoutComponent],
  templateUrl: './login.component.html',
  standalone: true,
})
export class LoginComponent implements OnInit {
  constructor(private cacheService: CacheService) {}

  ngOnInit() {
    this.cacheService.clearCache()
  }

  formForgotPass: boolean = false

  forgotPassword() {
    this.formForgotPass = !this.formForgotPass
  }
}
